module.exports = __webpack_public_path__ + "img/product_131.08c0b6d.svg";